// import Service from '@/service/index.js';
// import RegExpObj from '@/utils/regExp.js';
import synthesizeFormMixins from '../mixins/synthesize-form.js';
export default {
  mixins: [synthesizeFormMixins],
  data() {
    return {
      bidGeneralSituation: 6, // 农机设备信息
      // typeArr: [],
      massifs: [
        {
          massifName: '',
          manufactureBrand: '',
          productModel: '',
          manufactureDate: '',
          area: '',
          price: '',
          otherCondition: ''
        }
      ],
      rules: {
        massifName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        manufactureBrand: [
          { required: true, message: '请选择生产厂家或品牌', trigger: 'change' }
        ],
        manufactureDate: [
          { required: true, message: '请选择出厂日期', trigger: 'change' }
        ],
        productModel: [
          { required: true, message: '请选择规格型号', trigger: 'change' }
        ],
        area: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        otherCondition: [
          { required: true, message: '请输入配件及其他情况', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入地上附着物', trigger: 'blur' }
        ]
      },
      pickerDisabled: {
        disabledDate: (time) => {
          return time.getTime() > new Date(new Date()).getTime();
        }
      }
    };
  },
  // watch: {
  //   projectInfo: {
  //     handler() {
  //       const assetsInfoList = this.projectInfo && JSON.parse(this.projectInfo.assetsInfo);
  //       const assetsInfo = assetsInfoList.find(item => item.bidGeneralSituation === this.bidGeneralSituation);
  //       if (assetsInfo) {
  //         this.totalForm.sumArea = assetsInfo.sumArea;
  //         this.massifs = assetsInfo.massifs;
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    // priceVali(rule, value, callback){
    //   if(value === '' || value === null){
    //     callback(new Error('请输入总价格'));
    //   } else if(value < 1 || value > 9999999.99){
    //     callback(new Error('请输入0-10000000以内的数字'));
    //   } else {
    //     callback();
    //   }
    // },
    // areaVali(rule, value, callback){
    //   if(value === '' || value === null){
    //     callback(new Error('请输入数量'));
    //   } else if(value < 1 || value > 9999){
    //     callback(new Error('请输入0-10000以内的数字'));
    //   } else {
    //     callback();
    //   }
    // },
    clear(){
      if( this.projectInfo.projectType === 7) return false;
      this.massifs = [
        {
          massifName: '',
          manufactureBrand: '',
          productModel: '',
          manufactureDate: '',
          area: '',
          price: '',
          otherCondition: ''
        }
      ];
      this.totalForm = {
        sumArea: null
      };
      // 清空红色必填标示
      if(this.$refs['facilityForm']) {
        this.$refs['facilityForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        manufactureBrand: '',
        productModel: '',
        manufactureDate: '',
        area: '',
        price: '',
        otherCondition: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
      // let sumArea = 0;
      // this.massifs.forEach(item => {
      //   sumArea += Number(item.area);
      // });
      // this.totalForm.sumArea = sumArea.toFixed(2);
    }
    // changeArea (event, index) {
    //   if (!RegExpObj.num.test(this.massifs[index].area)) {
    //     return;
    //   }
    //   this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
    //   let num = 0;
    //   this.massifs.forEach(item => {
    //     num += Number(item.area);
    //   });
    //   this.totalForm.sumArea = num;
    // },
    // test() {
    //   return new Promise((resolve, reject) => {
    //     let num = 0;
    //     this.massifs.forEach((form, index) => {
    //       form.price = 0;
    //       this.$refs[`landForm${index}`][0].validate((valid) => {
    //         if (valid) {
    //           num ++;
    //         } else {
    //           reject();
    //         }
    //       });
    //     });
    //     if (num === this.massifs.length) {
    //       resolve({
    //         massifs: JSON.parse(JSON.stringify(this.massifs)),
    //         ...this.totalForm,
    //         bidGeneralSituation: this.bidGeneralSituation
    //       });
    //     } else {
    //       reject();
    //     }
    //   });
    // }
  }
};
